import React from 'react';

const Section = ({ children }) => (
  <div className="pt-8 w-full gap-4 max-w-7xl mx-auto justify-between lg:pt-12 lg:grid lg:grid-cols-11">
    {children}
  </div>
);
export default Section;
